import React from "react";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Button from "CustomButtons/Button.jsx";
import {formatDate,offsetUTCTimezone} from "components/helpers/DateTimeHelper.jsx";


const getMuiThemeForTable =  createMuiTheme({
    overrides: {
      MuiPaper: {
        elevation4: {
          boxShadow: "none"
        }
      },
      MUIDataTableToolbarSelect:{
        title:{
          display: "none"
        },
        root:{
          backgroundColor: "none",
          boxShadow: "none",
          justifyContent: "normal"
        }
      },
      MuiTableCell:{
        root:{
          padding: "4px 4px 4px 4px",
          textAlign: "center",
        },
        body:{
           fontSize: "12px"
        }
      },
      MUIDataTableHeadCell: {
        fixedHeader:{
          zIndex: "none"
        },
        toolButton:{
          width: "fit-content",
          margin: "auto"
        }
      },
    typography: {
      useNextVariants: true,
    },
    },
    typography: {
      useNextVariants: true,
    }
  })


class LiveUsersList extends React.Component {

  state = {
    testResults:[],
    testResultsTableColumns: [],
    downloadFile: true
  }

  componentDidMount(){
    this.populateTestResultDataTable(this.props.data);
  }

  componentDidUpdate(prevProps){
    if(this.props != prevProps ){
      this.populateTestResultDataTable(this.props.data);
    }
  }


  populateTestResultDataTable(data){
    var testResults=[];
    var testResultsTableColumns = []
    var results = data;
    if(!results || !results.length > 0){
      //TODO error message handling
      this.setState({testResults});
      return
    }
    if( results && results.length > 0){
      //Push actual results data to table
      for(var i=0; i < results.length ; i++){
        var resultRow = results[i]; 
        var testResultRow = []
        testResultRow.push(resultRow["global_user_id"]);
        testResultRow.push(resultRow["user_name"]);
        testResultRow.push(resultRow["name"]);      
        testResultRow.push(resultRow["status"]);
        testResultRow.push(resultRow["no_of_attempts"]);
        testResultRow.push(formatDate(offsetUTCTimezone(resultRow["created_at"])));
        testResultRow.push(formatDate(offsetUTCTimezone(resultRow["updated_at"])));
        testResultRow.push("");
        testResults.push(testResultRow);
      }

      //Push column names of table
      testResultsTableColumns.push(
        {name: "userId",
            options: {
              display: false,
            }
        }
      );
      testResultsTableColumns.push({name: "Username"});
      testResultsTableColumns.push({name: "Name"}); 
      testResultsTableColumns.push({name: "Status"});
      testResultsTableColumns.push({name: "No.of Attempts"});
      testResultsTableColumns.push({name: "Started At"});
      testResultsTableColumns.push({name: "Last Updated At"}); 
      testResultsTableColumns.push(
        {
          name: "",
          options: {
              customBodyRender: (value, tableMeta, updateValue) => {
              const linkButtonStyle = {
                textTransform: "none",
                backgroundColor: "#3f51b5",
                color: "white",
                borderRadius: "3px",
                padding: "0.3rem 0.75rem",
                boxShadow: "none",
                fontSize: "12px"
              }
              return (
              <div>
                  <Button
                    onClick={this.props.resetStudentAttempt}
                    name={tableMeta.rowData[0]}
                    style={linkButtonStyle}
                    size="sm"
                    disabled={tableMeta.rowData[3] != "ATTEMPTED"}
                    >
                     Reset Attempt
                  </Button>
              </div>
              );
              }
          }
        }
      );
      this.setState({testResultsTableColumns,testResults});
    }
  }

  render () {
    const tableTitleStyle={
      color: "rgb(34, 56, 69)",
      fontWeight: "600",
      fontSize: "18px",
      fontFamily: "open sans, Helvetica Neue, Helvetica, Arial, sans-serif",
      padding: "0px", margin: "0px",
      paddingTop: "10px"
    };
    const testResultsTableOptions = {
      filter: false,
      selectableRows: 'none',
      search: true,
      print: false,
      download: false,
      viewColumns: false,
      responsive: 'stacked',
      expandableRows: false,
      downloadOptions: {
        filename: this.props.reportName+ "_LiveStudents_"+ (new Date().toISOString().substring(0,16))+".csv",
        separator: ',',
      },
      download: true,
      onDownload: (buildHead, buildBody, columns, data) => 
        buildHead(columns) + buildBody(data),
    }
    return (
      <React.Fragment>
          <MuiThemeProvider theme={getMuiThemeForTable}>
            <MUIDataTable 
              title={<p style={tableTitleStyle} >{"Users Statistics"}</p>}
              options={testResultsTableOptions}
              columns={this.state.testResultsTableColumns}  
              data={this.state.testResults}              
            />
          </MuiThemeProvider>
      </React.Fragment>
    );
  }
}

export default LiveUsersList;
